import React from 'react';
import {
  AutocompleteInput,
  DateInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import { useForm, useFormState } from 'react-final-form';

import { CompetenciaInput } from '../../Components/InputsReactAdmin';
import { STATUS_ATIVO } from '../../utils/constants';

const choicesAcao = [
  { id: 'assinar', name: 'Assinar' },
  { id: 'visualizar', name: 'Visualizar' },
  { id: 'enviar_arquivo', name: 'Enviar arquivo' },
];

// Período de criação: "até" nunca fica antes de "a partir de". O seletor limita a data e, ao
// digitar uma data fora do limite, a do outro campo acompanha.
const CriadoDe = (props) => {
  const { values } = useFormState();
  const form = useForm();
  return (
    <DateInput
      {...props}
      inputProps={{ max: values.criado_ate || undefined }}
      onChange={(evento) => {
        const valor = evento && evento.target ? evento.target.value : evento;
        if (valor && values.criado_ate && valor > values.criado_ate)
          form.change('criado_ate', valor);
      }}
    />
  );
};

const CriadoAte = (props) => {
  const { values } = useFormState();
  const form = useForm();
  return (
    <DateInput
      {...props}
      inputProps={{ min: values.criado_de || undefined }}
      onChange={(evento) => {
        const valor = evento && evento.target ? evento.target.value : evento;
        if (valor && values.criado_de && valor < values.criado_de)
          form.change('criado_de', valor);
      }}
    />
  );
};

// Filtros da tela, no formato do drawer "Filtros avançados".
export const advancedFilters = [
  <ReferenceInput
    fullWidth
    label="Colaborador"
    source="colaborador_id"
    reference="colaboradores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    filter={{ status: STATUS_ATIVO }}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Modelo"
    source="modelo_documento_id"
    reference="modelos_documentos"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <SelectInput fullWidth label="Ação" source="acao" choices={choicesAcao} />,
  <ReferenceInput
    fullWidth
    label="Função do colaborador"
    source="funcao_id"
    reference="funcoes_colaboradores"
    sort={{ field: 'nome', order: 'ASC' }}
    filter={{ status: STATUS_ATIVO }}
    perPage={50}
  >
    <SelectInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Equipe do colaborador"
    source="equipe_id"
    reference="equipes_colaborador"
    sort={{ field: 'nome', order: 'ASC' }}
    perPage={50}
  >
    <SelectInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Grupo do colaborador"
    source="grupo_id"
    reference="grupos_colaborador"
    sort={{ field: 'nome', order: 'ASC' }}
    perPage={50}
  >
    <SelectInput optionText="nome" />
  </ReferenceInput>,
  <ReferenceInput
    fullWidth
    label="Loja do colaborador"
    source="loja_id"
    reference="empresa-loja"
    sort={{ field: 'nome_fantasia', order: 'ASC' }}
    perPage={50}
  >
    <SelectInput optionText="nome_fantasia" />
  </ReferenceInput>,
  <SelectInput
    fullWidth
    label="Sexo do colaborador"
    source="sexo"
    choices={[
      { id: 'masculino', name: 'Masculino' },
      { id: 'feminino', name: 'Feminino' },
    ]}
  />,
  <ReferenceInput
    fullWidth
    label="Assinante"
    source="colaborador_assinante_id"
    reference="colaboradores"
    sort={{ field: 'nome', order: 'ASC' }}
    filterToQuery={(searchText) => ({ nome: `${searchText}` })}
    filter={{ status: STATUS_ATIVO, is_user: true }}
    perPage={30}
  >
    <AutocompleteInput optionText="nome" />
  </ReferenceInput>,
  <CriadoDe fullWidth label="Criado a partir de" source="criado_de" />,
  <CriadoAte fullWidth label="Criado até" source="criado_ate" />,
  <CompetenciaInput
    fullWidth
    permiteAnual
    label="Competência"
    source="competencia"
  />,
];
